import { Box, Button, Grid, Typography, useTheme } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import AddIcon from "@mui/icons-material/Add";
import FilterListIcon from "@mui/icons-material/FilterList";
import { Dashboard as DashboardIcon } from "@mui/icons-material";
import moment, { Moment } from "moment";
import { useState } from "react";
import { PickerChangeHandlerContext } from "@mui/x-date-pickers/models";
import { DateValidationError } from "@mui/x-date-pickers";

interface DashboardHeaderProps {
    userName?: string;
    onDateChange?: (date: Date) => void;
    initialDate?: Date;
    onAddProduct?: () => void;
    onChangeFilter?: (filter: string) => void;
}

const DashboardHeader = ({
    userName = "User",
    onDateChange,
    initialDate = new Date(),
    onAddProduct,
    onChangeFilter,
}: DashboardHeaderProps) => {
    const theme = useTheme();
    const [selectedDate, setSelectedDate] = useState<Moment | null>(moment(initialDate));

    const handleDateChange = (date: Moment | null, context?: PickerChangeHandlerContext<DateValidationError>) => {
        setSelectedDate(date);
        if (date && onDateChange) {
            onDateChange(date.toDate());
        }
    };

    return (
        <Box sx={{ mb: 4, width: '100%' }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: { xs: "wrap", sm: "nowrap" },
                    gap: 2
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: 48,
                            height: 48,
                            borderRadius: 3,
                            backgroundColor: theme.palette.mode === 'dark'
                                ? theme.palette.primary.dark
                                : theme.palette.primary.light,
                            color: theme.palette.primary.contrastText,
                        }}
                    >
                        <DashboardIcon />
                    </Box>
                    <Box>
                        <Typography textAlign={"left"} variant="h4" fontWeight="bold" fontFamily="primaryFont">
                            Welcome {userName}
                        </Typography>
                        <Typography textAlign={"left"} variant="subtitle1" color="text.secondary" fontFamily="primaryFont">
                            Here's what happening with your store today
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    flexShrink: 0,
                    marginRight: 4
                }}>
                    <Typography variant="body2" color="text.secondary" fontFamily="primaryFont" sx={{ whiteSpace: 'nowrap' }}>
                        Filter by date
                    </Typography>
                    <DatePicker
                        value={selectedDate}
                        onChange={handleDateChange}
                        format="DD/MM/YYYY"
                        slotProps={{
                            textField: {
                                size: "small",
                                fullWidth: false,
                                sx: {
                                    minWidth: "150px",
                                    backgroundColor: theme.customColors.cardBackground,
                                    fontFamily: "primaryFont",
                                    fontSize: "0.875rem",
                                    "& .MuiInputBase-root": {
                                        fontFamily: "primaryFont",
                                        fontSize: "0.875rem"
                                    }
                                },
                            }
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default DashboardHeader; 